(function () {
  let deleteStepButtons = document.querySelectorAll(".js-delete-step");
  if (deleteStepButtons) {
    deleteStepButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        deleteStep(event);
      });
    });
  }

  function deleteStep(event) {
    let deletedItem = event.target.closest(".simple-card");
    if (deletedItem) {
      let steps = document.querySelector(".js-steps");
      let deleteInput = deletedItem.querySelector('input[name*="DELETE"]');
      let totalFormsInput = steps.querySelector(
        'input[type="hidden"][name*="TOTAL_FORMS"]'
      );

      deleteInput.value = "on";
      deletedItem.hidden = true;
      if (totalFormsInput) {
        totalFormsInput.value = parseInt(totalFormsInput.value) - 1;
      }
    }
  }
})();
